import React, { FunctionComponent, useMemo } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import Icon from '@gojob/ui-bits/Icon';
import LocationIcon from '@gojob/ui-bits/Icons/Location';
import Skeleton from '@gojob/ui-bits/Skeleton';
import Text from '@gojob/ui-bits/Text';

import useTheme from '@gojob/ui-bits/styles/useTheme';

export interface LocationProps extends FlexProps<'div'> {
  loading?: boolean;
  city?: string;
  postalCode?: string;
}

const Location: FunctionComponent<LocationProps> = (props) => {
  const { loading, city, postalCode, ...other } = props;
  const { spacing } = useTheme();

  const text = useMemo(() => {
    if (!city) {
      return '';
    }
    if (!postalCode) {
      return city;
    }
    return `${city} (${postalCode})`;
  }, [city, postalCode]);

  if (!text && !loading) {
    return null;
  }

  return (
    <Flex margin={[1, 0]} alignItems="center" {...other}>
      <Icon as={LocationIcon} color="primary" margin={[-0.5, 1.5, -0.5, -0.5]} />
      <Text as="h3">{loading ? <Skeleton width={spacing(14)} /> : text}</Text>
    </Flex>
  );
};

export default Location;
